import { httpsCallable } from 'firebase/functions';

// JADx Cash payment operations via Cloud Functions.
// Replaces StripePaymentManager. The order document must exist in Firestore
// BEFORE authorize is called — the backend reads the trusted total from it.
// Usage: jadPayments(functions).authorize({ orderId, rail, card, billing, tokenize })

const call = (functions, name) => httpsCallable(functions, name);

export function jadPayments(functions) {
  return {
    // Authorize (hold) the order total.
    // data: { orderId, rail: 'card'|'wallet', card?: {number, expMonth, expYear},
    //         savedCardId?: string, tokenize?: bool, billing: {...} }
    authorize: async (data) => (await call(functions, 'jadAuthorize')(data)).data,

    // Capture a held payment — called when the restaurant accepts the order.
    capture: async (orderId) => (await call(functions, 'jadCapture')({ orderId })).data,

    // Void a held payment — called on reject/cancel before capture.
    void: async (orderId, reason) => (await call(functions, 'jadVoid')({ orderId, reason })).data,

    status: async (orderId) => (await call(functions, 'jadStatus')({ orderId })).data,

    listCards: async () => (await call(functions, 'jadListCards')({})).data.cards || [],

    deleteCard: async (cardId) => (await call(functions, 'jadDeleteCard')({ cardId })).data,
  };
}

export default jadPayments;
